import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import LoginPage from "@/pages/LoginPage";
import DashboardLayout from "@/components/DashboardLayout";
import DashboardHome from "@/pages/DashboardHome";
import DrugsListPage from "@/pages/DrugsListPage";
import UserManagementPage from "@/pages/UserManagementPage";
import MyQueuePage from "@/pages/MyQueuePage";
import { Toaster } from "@/components/ui/sonner";

function ProtectedRoute({ children, adminOnly = false }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[#F8F7F4]">
                <div className="w-8 h-8 border-2 border-[#1A4331] border-t-transparent rounded-full animate-spin" />
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    if (adminOnly && user.role !== "admin") return <Navigate to="/my-queue" replace />;
    return children;
}

function HomeRedirect() {
    const { user } = useAuth();
    if (!user) return <Navigate to="/login" replace />;
    return <Navigate to={user.role === "admin" ? "/dashboard" : "/my-queue"} replace />;
}

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/login" element={<LoginPage />} />
                        <Route
                            element={
                                <ProtectedRoute>
                                    <DashboardLayout />
                                </ProtectedRoute>
                            }
                        >
                            <Route path="/" element={<HomeRedirect />} />
                            <Route path="/dashboard" element={
                                <ProtectedRoute adminOnly><DashboardHome /></ProtectedRoute>
                            } />
                            <Route path="/drugs" element={<DrugsListPage />} />
                            <Route path="/users" element={
                                <ProtectedRoute adminOnly><UserManagementPage /></ProtectedRoute>
                            } />
                            <Route path="/my-queue" element={<MyQueuePage />} />
                        </Route>
                        <Route path="*" element={<HomeRedirect />} />
                    </Routes>
                </BrowserRouter>
                <Toaster position="top-right" richColors />
            </AuthProvider>
        </div>
    );
}

export default App;
